import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Societe, SocieteEntityState } from '@get/api-interfaces';
import { SocieteRelationsIds } from '@get/store/ids-interfaces';

export const SocieteGeneratedActions = createActionGroup({
  source: 'Societe Generated',
  events: {
    'Get One Societe': props<{ idSociete: number; params?: any }>(),
    'Get Many Societes': props<{ params: any }>(),
    'Add Many Actives Societes': props<{ idSocietes: number[] }>(),
    'Delete One Active Societe': props<{ idSociete: number }>(),
    'Clear Actives Societes': emptyProps(),
    'Upsert One Societe': props<{ societe: Partial<Societe>; ids?: SocieteRelationsIds; }>(),
    'Upsert Many Societes': props<{ societes: Partial<Societe>[]; ids?: SocieteRelationsIds; }>(),
    'Upsert Many Societes Success': props<{ societes: SocieteEntityState[] }>(),
    'Delete One Societe': props<{ idSociete: number }>(),
    'Delete One Societe Success': props<{ idSociete: number }>(),
    'Normalize Many Societes After Upsert': props<{ societes: SocieteEntityState[] }>(),
    'Societes Failure': props<{ error: HttpErrorResponse }>(),
    'Clear Societes': emptyProps(),
    'Add Many Societe Composant Success': props<{ idSociete: number; idSocieteComposants: number[] }>(),
    'Delete Many Societe Composant Success': props<{ idSocieteComposants: number[]; idSocietes: number[] }>(),
    'Add Many Societe Patrimoine Hierarchie Success': props<{ idSociete: number; idSocietePatrimoineHierarchies: number[] }>(),
    'Delete Many Societe Patrimoine Hierarchie Success': props<{ idSocietePatrimoineHierarchies: number[]; idSocietes: number[] }>(),
    'Add Many Societe Caracteristique Success': props<{ idSociete: number; idSocieteCaracteristiques: number[] }>(),
    'Delete Many Societe Caracteristique Success': props<{ idSocieteCaracteristiques: number[]; idSocietes: number[] }>(),
    'Add Many Societe Composant Famille Success': props<{ idSociete: number; idSocieteComposantFamilles: number[] }>(),
    'Delete Many Societe Composant Famille Success': props<{ idSocieteComposantFamilles: number[]; idSocietes: number[] }>(),
    'Add Many Societe Espace Famille Success': props<{ idSociete: number; idSocieteEspaceFamilles: number[] }>(),
    'Delete Many Societe Espace Famille Success': props<{ idSocieteEspaceFamilles: number[]; idSocietes: number[] }>(),
    'Add Many Campagne Success': props<{ idSociete: number; idCampagnes: number[] }>(),
    'Delete Many Campagne Success': props<{ idCampagnes: number[]; idSocietes: number[] }>(),
    'Add Many Societe Territoire Success': props<{ idSociete: number; idSocieteTerritoires: number[] }>(),
    'Delete Many Societe Territoire Success': props<{ idSocieteTerritoires: number[]; idSocietes: number[] }>(),
    'Add Many Societe Profil Success': props<{ idSociete: number; idSocieteProfils: number[] }>(),
    'Delete Many Societe Profil Success': props<{ idSocieteProfils: number[]; idSocietes: number[] }>(),
    'Add Many Patrimoine Success': props<{ idSociete: number; idPatrimoines: number[] }>(),
    'Delete Many Patrimoine Success': props<{ idPatrimoines: number[]; idSocietes: number[] }>(),
    'Add Many Societe Config Analyse Synthese Success': props<{ idSociete: number; idSocieteConfigAnalyseSyntheses: number[] }>(),
    'Delete Many Societe Config Analyse Synthese Success': props<{ idSocieteConfigAnalyseSyntheses: number[]; idSocietes: number[] }>(),
    'Add Organisation Success': props<{ idSociete: number; idOrganisation: number }>(),
    'Delete Many Organisation Success': props<{ idOrganisations: number[]; idSocietes: number[] }>()
  }
});
